module.exports = __webpack_public_path__ + "img/susanImg2@2x.14fc183e.jpg";